import script from "./widget-notice.vue?vue&type=script&lang=ts&setup=true"
export * from "./widget-notice.vue?vue&type=script&lang=ts&setup=true"

import "./widget-notice.vue?vue&type=style&index=0&id=eda296ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda296ec"]])

export default __exports__